import { HIGRID_SYSTEM_COLUMN_IDS, isHiGridSystemColumnId } from './tanstackGridColumns';

/**
 * 저장된 열 순서 + 현재 컬럼 목록 → 시스템열은 항상 좌측 고정, 나머지 사용자 순서
 * @param {string[]} saved
 * @param {string[]} allColumnIds
 */
export function normalizeColumnOrder(saved, allColumnIds = []) {
  const ids = (allColumnIds || []).filter(Boolean);
  const system = ids.filter((id) => isHiGridSystemColumnId(id));
  const dataIds = ids.filter((id) => !isHiGridSystemColumnId(id));
  const savedData = (Array.isArray(saved) ? saved : []).filter((id) => dataIds.includes(id));
  const missing = dataIds.filter((id) => !savedData.includes(id));
  return [...system, ...savedData, ...missing];
}

/**
 * fromId 열을 toId 앞으로 이동. 시스템열은 이동 불가.
 * @returns {string[]|null} 변경된 순서. 불가 시 null
 */
export function moveColumnInOrder(order, fromId, toId) {
  if (!fromId || !toId || fromId === toId) return null;
  if (isHiGridSystemColumnId(fromId) || isHiGridSystemColumnId(toId)) return null;
  const next = [...(order || [])];
  const fromIdx = next.indexOf(fromId);
  const toIdx = next.indexOf(toId);
  if (fromIdx < 0 || toIdx < 0) return null;
  next.splice(fromIdx, 1);
  const insertAt = next.indexOf(toId);
  if (insertAt < 0) return null;
  next.splice(insertAt, 0, fromId);
  const system = next.filter((id) => isHiGridSystemColumnId(id));
  const data = next.filter((id) => !isHiGridSystemColumnId(id));
  return [...system, ...data];
}

/**
 * freezeToColumnId 까지가 고정 구간(시스템열 포함).
 * 경계를 넘는 이동이면 true.
 */
export function wouldCrossFreezeBoundary(order, fromId, toId, freezeToColumnId) {
  if (!freezeToColumnId) return false;
  const frozen = frozenIdSet(order, freezeToColumnId);
  const fromFrozen = frozen.has(fromId);
  const toFrozen = frozen.has(toId);
  return fromFrozen !== toFrozen;
}

export function frozenIdSet(order, freezeToColumnId) {
  const set = new Set(HIGRID_SYSTEM_COLUMN_IDS);
  if (!freezeToColumnId || !order?.length) return set;
  for (const id of order) {
    set.add(id);
    if (id === freezeToColumnId) break;
  }
  return set;
}

export { isHiGridSystemColumnId };
